module.exports = __webpack_public_path__ + "assets/b100.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b100.png
// module id = 571
// module chunks = 0